import React from 'react';

import PropTypes from 'prop-types';

import Banner from '@adsk/alloy-react-banner';
import { useLocale } from '@adsk/alloy-react-locale';

const DocsCustomTopBanner = ({ multiple }) => {
  const shouldHideBanner = localStorage.getItem(
    'file-reference-picker-hide-banner',
  );
  const [isOpen, setIsOpen] = React.useState(shouldHideBanner !== 'true');
  const setClose = () => {
    try {
      localStorage.setItem('file-reference-picker-hide-banner', true);
    } catch (e) {
      console.error(e);
    }
    setIsOpen(false);
  };
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  return multiple && isOpen ? (
    <Banner
      inline
      message={T.translate('SHIFT_SELECTION_BANNER_MESSAGE')}
      variant={Banner.VARIANTS.PRIMARY}
      open={isOpen}
      onClose={setClose}
    />
  ) : null;
};

DocsCustomTopBanner.propTypes = {
  multiple: PropTypes.bool,
};

export default DocsCustomTopBanner;
